// eslint-disable-next-line import/no-named-as-default
import { api } from './base.service';

export const getSectorRoles = () => {
  return api().get('/api/sector-roles');
};
